import React from 'react';
import SimpleFullPageChat from '../components/Chat/SimpleFullPageChat';

const FullPageChatPage: React.FC = () => {
  return <SimpleFullPageChat />;
};

export default FullPageChatPage;